import { api } from "../config/api";

export const incrementInvoiceNumber = (currentNumber) => {
    // Accept strings or numbers; coerce to string
    const value = (currentNumber ?? '').toString().trim();
    if (!value) return '0001';

    try {
        // Extract trailing number (if any)
        const match = value.match(/(\d+)$/);
        if (match) {
            const numberPart = match[1];
            const prefix = value.slice(0, value.length - numberPart.length);

            // Increment while preserving zero-padding
            const nextNumber = (parseInt(numberPart, 10) + 1).toString();
            const paddedNumber = nextNumber.padStart(numberPart.length, '0');
            return prefix + paddedNumber;
        }

        // If no trailing digits exist, start sequence at 001
        return value + '001';
    } catch (error) {
        console.error("Error incrementing invoice number:", error);
        return '0001'; // Safe fallback
    }
};

export const getNextInvoiceNumber = async () => {
    try {
        const response = await api.get("/invoice/next-number");
        return response?.data?.invoiceNo || '0000';
    } catch (error) {
        console.error("Error getting next invoice number:", error);
        return '0000';
    }
};
